export const generateSchema = (entry, siteIdentity = {}) => {
  const { $localeRootPath } = useNuxtApp();
  const pageId = $localeRootPath('/' + entry.uri);

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'ProfilePage',
    mainEntity: {
      '@type': 'Person',
      name: entry.title,
      description: entry.description || entry.heading,
      url: pageId,
      image: entry.image?.[0]?.url,
      jobTitle: entry.jobTitle,
      worksFor: {
        '@type': 'Organization',
        name: siteIdentity.name || 'BLACKROLL',
      },
    },
  };

  return schema;
};
